/** Texte der gemeinsamen Theme-Bausteine; Produkte übernehmen sie in ihre Wörterbücher. */
export const themeDe = {
  "Theme.menu": "Design",
  "Theme.drawerTitle": "Design",
  "Theme.apply": "übernehmen",
  "Theme.choose": "Design wählen",
  "Theme.cancel": "abbrechen",
  "Theme.preview": "ansehen",
  "Theme.badge.appDefault": "App-Standard",
  "Theme.badge.teamDefault": "Team-Standard",
  "Theme.family.noir": "Noir",
  "Theme.family.kraftraum": "Kraftraum",
  "Theme.family.classic": "Klassisch Blau",
  "Theme.family.slate": "Schiefer",
  "Theme.family.kontor": "Kontor",
  "Theme.family.violet": "Klassisch Violett",
  "Theme.family.teal": "Klassisch Türkis",
  "Theme.family.green": "Klassisch Grün",
  "Theme.family.vital": "Vital",
  "Theme.family.web": "mQorva Web",
  "Theme.family.impuls": "Impuls",
  "Theme.family.pflaume": "Pflaume",
  "Theme.brightness.light": "hell",
  "Theme.brightness.dark": "dunkel",
  "Theme.zoom": "Anzeigegröße",
  "Theme.admin.title": "Designs",
  "Theme.admin.available": "verfügbar",
  "Theme.admin.default": "Standard",
  "Theme.admin.saved": "Designs gespeichert",
  "Theme.tenant.title": "Standard-Design",
  "Theme.tenant.appDefault": "wie App-Standard",
  "Theme.tenant.saved": "Standard-Design gespeichert",
  "Theme.save": "speichern",
  "Theme.loadFailed": "Designs konnten nicht geladen werden.",
  "Theme.saveFailed": "Designs konnten nicht gespeichert werden.",
  "appearance.theme_unknown": "Dieses Design gibt es nicht.",
  "appearance.no_theme_available": "Mindestens ein Design muss verfügbar sein.",
  "appearance.default_not_available": "Das Standard-Design muss verfügbar sein.",
  "appearance.theme_not_available": "Dieses Design ist in der App nicht freigegeben.",
};

export const themeEn: Record<keyof typeof themeDe, string> = {
  "Theme.menu": "Appearance",
  "Theme.drawerTitle": "Appearance",
  "Theme.apply": "Apply",
  "Theme.choose": "Choose theme",
  "Theme.cancel": "Cancel",
  "Theme.preview": "Preview",
  "Theme.badge.appDefault": "App default",
  "Theme.badge.teamDefault": "Team default",
  "Theme.family.noir": "Noir",
  "Theme.family.kraftraum": "Kraftraum",
  "Theme.family.classic": "Classic Blue",
  "Theme.family.slate": "Slate",
  "Theme.family.kontor": "Ledger",
  "Theme.family.violet": "Classic Violet",
  "Theme.family.teal": "Classic Teal",
  "Theme.family.green": "Classic Green",
  "Theme.family.vital": "Vital",
  "Theme.family.web": "mQorva Web",
  "Theme.family.impuls": "Impuls",
  "Theme.family.pflaume": "Plum",
  "Theme.brightness.light": "light",
  "Theme.brightness.dark": "dark",
  "Theme.zoom": "Display size",
  "Theme.admin.title": "Themes",
  "Theme.admin.available": "available",
  "Theme.admin.default": "Default",
  "Theme.admin.saved": "Themes saved",
  "Theme.tenant.title": "Default theme",
  "Theme.tenant.appDefault": "Same as app default",
  "Theme.tenant.saved": "Default theme saved",
  "Theme.save": "Save",
  "Theme.loadFailed": "Themes could not be loaded.",
  "Theme.saveFailed": "Themes could not be saved.",
  "appearance.theme_unknown": "This theme does not exist.",
  "appearance.no_theme_available": "At least one theme must be available.",
  "appearance.default_not_available": "The default theme must be available.",
  "appearance.theme_not_available": "This theme is not enabled in the app.",
};

export const themeRu: Record<keyof typeof themeDe, string> = {
  "Theme.menu": "Оформление",
  "Theme.drawerTitle": "Оформление",
  "Theme.apply": "применить",
  "Theme.choose": "выбрать оформление",
  "Theme.cancel": "отменить",
  "Theme.preview": "посмотреть",
  "Theme.badge.appDefault": "стандарт приложения",
  "Theme.badge.teamDefault": "стандарт команды",
  "Theme.family.noir": "Noir",
  "Theme.family.kraftraum": "Kraftraum",
  "Theme.family.classic": "Классика синяя",
  "Theme.family.slate": "Сланец",
  "Theme.family.kontor": "Контора",
  "Theme.family.violet": "Классика фиолетовая",
  "Theme.family.teal": "Классика бирюзовая",
  "Theme.family.green": "Классика зелёная",
  "Theme.family.vital": "Vital",
  "Theme.family.web": "mQorva Web",
  "Theme.family.impuls": "Impuls",
  "Theme.family.pflaume": "Слива",
  "Theme.brightness.light": "светлое",
  "Theme.brightness.dark": "тёмное",
  "Theme.zoom": "Масштаб",
  "Theme.admin.title": "Оформления",
  "Theme.admin.available": "доступно",
  "Theme.admin.default": "стандарт",
  "Theme.admin.saved": "Оформления сохранены",
  "Theme.tenant.title": "Стандартное оформление",
  "Theme.tenant.appDefault": "как в приложении",
  "Theme.tenant.saved": "Стандартное оформление сохранено",
  "Theme.save": "сохранить",
  "Theme.loadFailed": "Не удалось загрузить оформления.",
  "Theme.saveFailed": "Не удалось сохранить оформления.",
  "appearance.theme_unknown": "Такого оформления нет.",
  "appearance.no_theme_available": "Должно быть доступно хотя бы одно оформление.",
  "appearance.default_not_available": "Стандартное оформление должно быть доступно.",
  "appearance.theme_not_available": "Это оформление не разрешено в приложении.",
};

export const themeUk: Record<keyof typeof themeDe, string> = {
  "Theme.menu": "Оформлення",
  "Theme.drawerTitle": "Оформлення",
  "Theme.apply": "застосувати",
  "Theme.choose": "вибрати оформлення",
  "Theme.cancel": "скасувати",
  "Theme.preview": "переглянути",
  "Theme.badge.appDefault": "стандарт застосунку",
  "Theme.badge.teamDefault": "стандарт команди",
  "Theme.family.noir": "Noir",
  "Theme.family.kraftraum": "Kraftraum",
  "Theme.family.classic": "Класика синя",
  "Theme.family.slate": "Сланець",
  "Theme.family.kontor": "Контора",
  "Theme.family.violet": "Класика фіолетова",
  "Theme.family.teal": "Класика бірюзова",
  "Theme.family.green": "Класика зелена",
  "Theme.family.vital": "Vital",
  "Theme.family.web": "mQorva Web",
  "Theme.family.impuls": "Impuls",
  "Theme.family.pflaume": "Слива",
  "Theme.brightness.light": "світле",
  "Theme.brightness.dark": "темне",
  "Theme.zoom": "Масштаб",
  "Theme.admin.title": "Оформлення",
  "Theme.admin.available": "доступно",
  "Theme.admin.default": "стандарт",
  "Theme.admin.saved": "Оформлення збережено",
  "Theme.tenant.title": "Стандартне оформлення",
  "Theme.tenant.appDefault": "як у застосунку",
  "Theme.tenant.saved": "Стандартне оформлення збережено",
  "Theme.save": "зберегти",
  "Theme.loadFailed": "Не вдалося завантажити оформлення.",
  "Theme.saveFailed": "Не вдалося зберегти оформлення.",
  "appearance.theme_unknown": "Такого оформлення немає.",
  "appearance.no_theme_available": "Має бути доступне хоча б одне оформлення.",
  "appearance.default_not_available": "Стандартне оформлення має бути доступним.",
  "appearance.theme_not_available": "Це оформлення не дозволено в застосунку.",
};

export const themeIt: Record<keyof typeof themeDe, string> = {
  "Theme.menu": "Aspetto",
  "Theme.drawerTitle": "Aspetto",
  "Theme.apply": "applica",
  "Theme.choose": "scegli aspetto",
  "Theme.cancel": "annulla",
  "Theme.preview": "anteprima",
  "Theme.badge.appDefault": "standard dell'app",
  "Theme.badge.teamDefault": "standard del team",
  "Theme.family.noir": "Noir",
  "Theme.family.kraftraum": "Kraftraum",
  "Theme.family.classic": "Classico blu",
  "Theme.family.slate": "Ardesia",
  "Theme.family.kontor": "Ufficio",
  "Theme.family.violet": "Classico viola",
  "Theme.family.teal": "Classico turchese",
  "Theme.family.green": "Classico verde",
  "Theme.family.vital": "Vital",
  "Theme.family.web": "mQorva Web",
  "Theme.family.impuls": "Impuls",
  "Theme.family.pflaume": "Prugna",
  "Theme.brightness.light": "chiaro",
  "Theme.brightness.dark": "scuro",
  "Theme.zoom": "Dimensione",
  "Theme.admin.title": "Temi",
  "Theme.admin.available": "disponibile",
  "Theme.admin.default": "standard",
  "Theme.admin.saved": "Temi salvati",
  "Theme.tenant.title": "Tema standard",
  "Theme.tenant.appDefault": "come nell'app",
  "Theme.tenant.saved": "Tema standard salvato",
  "Theme.save": "salva",
  "Theme.loadFailed": "Impossibile caricare i temi.",
  "Theme.saveFailed": "Impossibile salvare i temi.",
  "appearance.theme_unknown": "Questo tema non esiste.",
  "appearance.no_theme_available": "Deve essere disponibile almeno un tema.",
  "appearance.default_not_available": "Il tema standard deve essere disponibile.",
  "appearance.theme_not_available": "Questo tema non è abilitato nell'app.",
};
